import { takeLatest, put, call } from 'redux-saga/effects';
import request from '../../components/Utils/httpHelper';
import * as ifscUserMasterActions from './action';
import { CORE_API } from '../../config';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants'
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from './IfscUserMasterTable/constants';

export function* ifscUserMasterTemplateRequest(action) {
    let requestURL = `${CORE_API}/ifsc-user/masters/template`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(ifscUserMasterActions.ifscUserMasterTemplateSuccess({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(ifscUserMasterActions.ifscUserMasterTemplateFailure({ ...err.response, status: "FAILURE" }))
    }
}

export function* ifscUserMasterTemplate() {
    yield takeLatest(ifscUserMasterActions.IFSC_USER_MASTER_TEMPLATE_REQUEST, ifscUserMasterTemplateRequest);
}

export function* submitIfscUserMasterRequestSaga(action) {
    const formData = new FormData();
    formData.append('file', action.data.file);
    let requestUrl = "";
    let methodtype = "";
    if(action.data.type === 'add'){
        methodtype="POST"
        requestUrl = `${CORE_API}/ifsc-user/masters`;
    }
    if(action.data.type === 'edit'){
         methodtype="PUT"
        requestUrl = `${CORE_API}/ifsc-user/masters`;
    }
    try {
        const searchResult = yield call(request, requestUrl, { data: formData, method: methodtype, headers: HTTP_HEADERS_FORMDATA, responseType: 'blob' });
        
        // Check if response is JSON or Blob
        if (searchResult.data instanceof Blob && searchResult.data.type === 'application/json') {
            // It's a JSON blob, convert to JSON
            const text = yield searchResult.data.text();
            const jsonData = JSON.parse(text);
            yield put(ifscUserMasterActions.addIfscUserMasterUploadSuccess(jsonData));
        } else if (searchResult.data instanceof Blob) {
            // Binary response (shouldn't happen on success, but handle it)
            const text = yield searchResult.data.text();
            const jsonData = JSON.parse(text);
            yield put(ifscUserMasterActions.addIfscUserMasterUploadSuccess(jsonData));
        } else {
            // Direct JSON response
            yield put(ifscUserMasterActions.addIfscUserMasterUploadSuccess(searchResult.data));
        }
    } catch (err) {
        // Check if error response is Excel file or JSON
        if (err.response && err.response.data instanceof Blob) {
            const contentType = err.response.data.type;
            
            // Backend returns Excel errors as application/octet-stream
            if (contentType && (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || 
                contentType.includes('application/octet-stream'))) {
                // It's an Excel file - convert to ArrayBuffer
                const arrayBuffer = yield err.response.data.arrayBuffer();
                yield put(ifscUserMasterActions.addIfscUserMasterUploadFailureFile(arrayBuffer));
            } else if (contentType && contentType.includes('application/json')) {
                // It's a JSON error
                const text = yield err.response.data.text();
                const jsonError = JSON.parse(text);
                yield put(ifscUserMasterActions.addIfscUserMasterUploadFailure(jsonError));
            } else {
                // Unknown blob type, try to read as text
                const text = yield err.response.data.text();
                try {
                    const jsonError = JSON.parse(text);
                    yield put(ifscUserMasterActions.addIfscUserMasterUploadFailure(jsonError));
                } catch (parseErr) {
                    yield put(ifscUserMasterActions.addIfscUserMasterUploadFailure({ message: text || "Upload failed" }));
                }
            }
        } else {
            // Regular error message
            yield put(ifscUserMasterActions.addIfscUserMasterUploadFailure(err.response?.data || { message: "Upload failed" }));
        }
    }
}

export function* submitIfscUserMasterRequest() {
    yield takeLatest(ifscUserMasterActions.ADD_IFSC_USER_MASTER_UPLOAD, submitIfscUserMasterRequestSaga);
}


export function* ifscUserMasterDataExcelRequest(action) {
    let requestURL = `${CORE_API}/ifsc-user/masters/export`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(ifscUserMasterActions.ifscUserMasterDataExcelSuccess({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(ifscUserMasterActions.ifscUserMasterDataExcelFailure({ ...err.response, status: "FAILURE" }))
    }
}

export function* ifscUserMasterDataExcel() {
    yield takeLatest(ifscUserMasterActions.IFSC_USER_MASTER_DATA_EXCEL_REQUEST, ifscUserMasterDataExcelRequest);
}


export function* ifscUserMasterListSaga(action) {
  const { pageNumber = DEFAULT_PAGE_NUMBER, pageSize = DEFAULT_PAGE_SIZE, filter = {}, sorted = [{ id: "createdAt", desc: true }]} = action.data || {}

  const sortDirection = sorted.desc ? 'desc' : 'asc', sortField = sorted.id || 'createdAt'

  const requestURL = `${CORE_API}/ifsc-user/masters/list/${pageNumber}/${pageSize}/sort/${sortField}/${sortDirection}`;
  try {
    const response = yield call(request, requestURL, {
      method: 'POST',
      headers: HTTP_HEADERS,
      data: filter
    });

    yield put(ifscUserMasterActions.ifscUserMasterListSuccess(response.data));
  } catch (err) {
    yield put(
      ifscUserMasterActions.ifscUserMasterListFailure(
        err.response?.data || { message: 'Failed to fetch IFSC User Master list' }
      )
    );
  }
}

export function* fetchIfscUserMasterList() {
    yield takeLatest(ifscUserMasterActions.IFSC_USER_MASTER_LIST_REQUEST, ifscUserMasterListSaga);
}
